import { ChainItem, ChainList } from './style'
import { getChains } from 'src/config/cache/chains'
import Block from 'src/components/layout/Block'
import { useCallback, useEffect } from 'react'
import { ChainId } from 'src/config/chain'
import { setChainId } from 'src/logic/config/utils'
import { ChainInfo } from '@gnosis.pm/safe-apps-sdk'
import { useStepper } from 'src/components/StepperWalliro/stepperContext'

interface Props {
  selectedNetwork: ChainInfo
  locationNetwork?: ChainId
  resetLocationNetwork: () => void
}
const StepOne = ({ selectedNetwork, locationNetwork, resetLocationNetwork }: Props) => {
  const {
    currentStep,
    setCurrentStep,
    steps,

    onClickPreviousStep,
    onClickNextStep,

    disableNextButton,
    nextButtonType,

    testId,
    trackingCategory,
  } = useStepper()

  const onNetworkSwitch = useCallback((chainId: ChainId) => {
    setChainId(chainId)
  }, [])

  const onGoToTron = (id: string) => {
    window.location.href = 'https://tron.walliro.com/starter?network=' + id
  }

  useEffect(() => {
    if (typeof locationNetwork !== 'undefined') {
      setCurrentStep(1)
      resetLocationNetwork()
    }
    // onClickNextStep()
  }, [locationNetwork])

  return (
    <Block className="px-lg-5 py-lg-4 p-3">
      <ChainList>
        <ChainItem size="md" className="my-2" onClick={() => onGoToTron('https://api.trongrid.io')}>
          Tron - Mainnet
        </ChainItem>
        <ChainItem size="md" className="my-2" onClick={() => onGoToTron('https://api.shasta.trongrid.io')}>
          Tron - Shasta (Testnet)
        </ChainItem>
        {getChains().map((network, index) => (
          <ChainItem
            key={index}
            size="md"
            className="my-2"
            onClick={() => onNetworkSwitch(network.chainId)}
            $isActive={selectedNetwork.chainId === network.chainId}
          >
            {network.chainName}
          </ChainItem>
        ))}
        {/* <ChainItem size="md" className="my-2" disabled>
          Bitcoin
        </ChainItem> */}
      </ChainList>
    </Block>
  )
}

export default StepOne
